<script>
  import {mapGetters, mapState} from 'vuex'
  import Service from '../../../domain/chat/services/chat'
  import ChatUsuarios from './ChatUsuarios.vue'
  import ChatConversa from './ChatConversa'
  import UChatMenuOptions from './ChatMenuOptions'

  window.chatIsLoaded = true

  export default {
    name: 'chat',
    data () {
      return {
        open: false,
        isLoading: true,
        isLoadingSend: false,
        mensagens: [],
        mensagem: '',
        filterKey: ''
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'isLogged', 'isChatOpened', 'chatActualUser']),
      ...mapState({
        destinatario: state => state.chat.user
      }),
      firstName () {
        return this.currentUser.nome && this.currentUser.nome.split(' ').shift()
      }
    },
    mounted () {
      this._interval = null
    },
    destroyed () {
    },
    watch: {
      destinatario: function (val) {
        if (val) {
          this.loadMessages(this.chatActualUser.id, null)
        }
      },
      isChatOpened: function (val) {
        if (val) { // perspectiva de quem enviou, não do usuário atual
          // remetenteid == destinatario
          // destinatarioid == currentUser
          Service.setVisualizado(this.destinatario.id, this.currentUser.id)
            .then(result => {
              console.log(result.data)
            })
        }
      }
    },
    methods: {
      openChat () {
        this.open = true
        this.$root.$el.classList.add('showChat')
      },
      toggle () {
        if (this.open) {
          this.closeChat()
        } else {
          this.openChat()
        }
      },
      closeChat () {
        this.open = false
        this.$root.$el.classList.remove('showChat')
      },
      clearInterval () {
        window.clearInterval(this._interval)
        delete this._interval
      },
      createInterval () {
        window.clearInterval(this._interval)
        this._interval = window.setInterval(() => {
          if (!window.chatIsLoaded) {
            return
          }
          window.chatIsLoaded = false
          Service.loadMessages(this.chatActualUser.id, null).then(result => {
            window.chatIsLoaded = true
            this.mensagens = result.data
          })
            .catch(error => {
              window.chatIsLoaded = true
              console.log(error)
            })
        }, 3000)
      },
      loadMessages () {
        this.createInterval()
        this.isLoading = true
        Service.loadMessages(this.chatActualUser.id, null).then(result => {
          this.mensagens = result.data
          this.isLoading = false
          this.$nextTick(() => {
            this.$refs.inputMensagem.focus()
          })
        })
          .catch(error => {
            this.isLoading = false
            console.log(error)
          })
      },
      enviaMensagem () {
        if (this.mensagem.length === 0) {
          return
        }
        let _mensagem = JSON.parse(JSON.stringify(this.mensagem))
        this.mensagem = ''
        this.isLoadingSend = true
        Service.sendMessage(this.destinatario.id, null, {mensagem: _mensagem}).then(result => {
          this.mensagens.push(result.data)
          this.isLoadingSend = false
        })
          .catch(error => {
            this.isLoadingSend = false
            console.log(error.response)
          })
      },
      updateNotReaded (mensagens) {
        if (typeof mensagens !== 'undefined' && mensagens !== null && mensagens.length > 0) {
          this.$refs.chatUsuarios.updateNotReaded(mensagens)
        }
      },
      pesquisaUsuario (filtro) {
        this.filterKey = filtro
      }
    },
    deactivated () {
      this.clearInterval() // no keep-alive
    },
    components: {
      UChatMenuOptions,
      ChatConversa,
      ChatUsuarios
    }
  }
</script>

<template>
  <div v-if="isLogged" class="chat-container">

    <div class="chat-float" :class="{open: open}">
      <chat-usuarios class="chat-content" :filter-key="filterKey" ref="chatUsuarios"></chat-usuarios>
      <u-chat-menu-options @pesquisa="pesquisaUsuario"></u-chat-menu-options>
    </div>

    <div class="chat-conversas">
      <div id="chat-conversas-container" class="chat-conversas-container">
        <!-- CHAT INSTANCES -->
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// Chat.vue?262a3006